(function () {
    angular.module('tmx-app').factory('UsersService', ['$http', 'tmxResource', '$q', 'tmxUtility', 'lookupService','APP_CONSTANTS', 'TMX_FINANCE_CONSTANTS','BranchService','cacheStore',
        function ($http, tmxResource, $q, tmxUtility, lookupService,APP_CONSTANTS,TMX_FINANCE_CONSTANTS,BranchService,cacheStore) {

            var Users = tmxResource("User");

            function httpConfig(method, url, data) {
                this.url = url;
                this.method = method;
                this.data = data;
            }

            Users.getAllUsers = function () {
                return Users.all();
            };
            Users.getBranchesLov = function(){
                var companyBranchesLov = cacheStore.get("CompanyBranchesLov");
                if(!companyBranchesLov){
                    BranchService.lov().then(onBranchLovLoad);
                }
                else{
                    onBranchLovLoad(companyBranchesLov);
                }
                function onBranchLovLoad(response){
                    if (response) {
                        cacheStore.get("CompanyBranchesLov",response);
                        Users.branches= response.data;
                        Users.gridColumn[2].data=Users.branches;                  
                    }
                }
            }

            Users.getUserByRole = function (RoleId) {
                RoleId = RoleId == null ? 0 : RoleId;
                return Users.getByAction("?filter=RoleID~eq~" + RoleId, true);
            }

            Users.getUserByBranch = function (branchId) {
                if (branchId) { return Users.getByAction("?filter=CompanyBranchId~contains~' " + branchId + ",'", true); }
                else { return Users.getByAction("", true); }

            }

            Users.getUsersByLocation = function (branchId, roleId) {
                var filter = "";
                if (branchId) {
                    filter = "filter=CompanyBranchId~contains~'" + branchId + "'";
                }
                if (roleId) {
                    if (branchId) {
                        filter += '~and~';
                        filter += 'RoleID~eq~' + roleId;
                    }
                    else {
                        filter += "filter=RoleID~eq~" + roleId;
                    }
                }

                if (branchId || roleId) {
                    return Users.getByAction("?" + filter + "~and~RoleID~neq~'null'~and~Status~eq~%27Active%27", true);
                }
                else {
                    return Users.getByAction("?filter=RoleID~neq~'null'~and~Status~eq~%27Active%27", true);
                }
            }

            Users.getUsersByType = function (typeId) {
                return Users.getByAction("GetUsersByType/" + typeId, true);
            }

            Users.getUserByRoleNames = function (roleNames, branchId) {
                return Users.getByAction("GetUsersByRole/" + encodeURI(roleNames) + "/" + branchId, true);
            }

            Users.getById = function (id, successcb, errorcb) {

                return Users.thenFactoryMethod(new httpConfig('get', Users.url + '/GetById/' + id), successcb, errorcb);
            };


            Users.DesignationsLov = function () {
                return Users.getByAction("designation", true);
            };

            Users.ManagersLov = function () {

                return Users.getByAction("manager", true);
            };

            Users.BMLov = function () { 


                var deferred = $q.defer();
                return deferred.promise;
            };

            Users.getUserByUserName = function (username) {
                return Users.getByAction("GetCurrentUserByUsername", false, 'post', { "UserName": username });
            }
            Users.loginToMF = function (loginParams) {
                return Users.getByAction("Login", false, 'post',loginParams);
            }
            Users.logoutUser = function () {
                return Users.getByAction("Logout", false, 'post');
            }

            Users.getCurrentUser = function () {
                return Users.getByAction("GetCurrentUser ", true);
            }

            Users.getUserByBranchId = function (branchId) {
                return Users.getByAction("GetUserbyBranch/" + branchId, true);
            }

            Users.ActiveLov = function () {
                var data = {
                    Parameter: "ACTIVE"
                };
                return Users.getByAction("lov", true, "put", data);
            };
            // eslint-disable-next-line no-unused-vars
            Users.GetUserRole = function (id) {

        //return  tmxResource("User/GetUserRolesById/").getById(id);
            };

            Users.UnassignedLov = function (devId) {
                let data;
                if (angular.isDefined(devId) && devId != null)
                    data = {
                        DeviceId: devId,
                        Parameter: "DEVICE"
                    };
                else
                    data = {
                        Parameter: "UNASSIGNED"
                    };
                return Users.getByAction("lov", true, "put", data);
        // var httpPromise = $http.get(Users.url + '/manager');
        // return Users.thenFactoryMethod(httpPromise, successcb, errorcb, true);
            };

            Users.deleteById = function (id) {
                var deferred = $q.defer();
                Users.getById(id).then(function (result) {
                    deferred.resolve(result.$remove());
                });
        // item.$remove();
                return deferred.promise;
            };

            Users.getUserFromAuth  =function(id){
                var deferred = $q.defer();
                var data = {};
                $http.get(APP_CONSTANTS.AuthServer + '/api/user/'+id).then(function (response) {
                    if(response){
                        data = response.data;
                    }
                    deferred.resolve(data);
                }, function(){
                    deferred.resolve(data);
                });
                return deferred.promise;
      
            }


            Users.status = [
                {
                    HiddenValue: "active",
                    VisibleValue: "Active"
                },
                {
                    HiddenValue: "inactive",
                    VisibleValue: "Inactive"
                },
                {
                    HiddenValue: "pending",
                    VisibleValue: "Pending"
                }


            ];

            Users.gridColumn = [               
                {
                    field: "Name",
                    title: "Name",
                    type: "text",          
                    width: "30%",          
                    template: "<md-button class='tmx-primary-text-grid' ng-disabled='!dataItem.editable || !UsersCtrl.EditPrivilege' ng-click='UsersCtrl.clickEdit(dataItem)' ng-bind='dataItem.Name'></md-button> <div class='margin-bottom-2'> <span class='chip' ng-style={{dataItem.StatusBKColor}} ng-bind='dataItem.Status'></span> <span class='subtitle'> {{dataItem.PhoneNumber1}} </span> <span class='subtitle' ng-bind='dataItem.EmailAddress'> </span> </div>  ",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('FirstName')}\" >{{'Name' | translate}}<i class='fa fa-filter'ng-if='UsersCtrl.isFiltered(\"FirstName\")' ></i></span>"
                },
                {
                    field: "PhoneNumber1",
                    title: "Phone",
                    type: "numeric",
                    hidden:true,                    
                    template: "{{dataItem.PhoneNumber1}}",
                    headerTemplate: "<span class=\"k-link\"  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('PhoneNumber1')}\" >{{'Phone' | translate}}<i class='fa fa-filter' ng-if='UsersCtrl.isFiltered(\"PhoneNumber1\")' ></i></span>"
                },
                {
                    field: "BranchName",
                    title: "BranchName",                    
                    type: "select",
                    data: Users.branches,              
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('BranchName')}\" >{{'BranchName' | translate}}<i class='fa fa-filter' ng-if='UsersCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field: "UserTypeLkpID",
                    title: "UserType",
                    type: "select",
                    data: Users.userTypes,
                    template:"{{dataItem.userType}}",
                    // isNumber: true,                    
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('UserTypeLkpID')}\" >{{'UserType' | translate}}<i class='fa fa-filter' ng-if='UsersCtrl.isFiltered(\"UserTypeLkpID\")' ></i></span>"
                },
                {
                    field: "EmailAddress",
                    title: "Email",
                    type: "email",
                    hidden:true,                    
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('EmailAddress')}\" >{{'Email' | translate}}<i class='fa fa-filter' ng-if='UsersCtrl.isFiltered(\"EmailAddress\")' ></i></span>"
                },
                {
                    field: "RoleName",
                    title: "Role",
                    type: "text",                                      
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('RoleName')}\" >{{'Role' | translate}}<i class='fa fa-filter' ng-if='UsersCtrl.isFiltered(\"RoleName\")' ></i></span>"
                },
                {
                    field: "Status",
                    title: "Status",
                    type: "select",
                    data: Users.status,                    
                    hidden:true,                    
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : UsersCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='UsersCtrl.isFiltered(\"Status\")' ></i></span>"
                },
                {
                    title: "",
                    width: "5%",
                    template: "<md-menu md-position-mode=\"target-right target\" flex='none' class='menu-list-item' md-offset='-20 60'>"
                                    +"<md-button  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons margin-right-24'>more_vert</md-icon></md-button>"
                                        +"<md-menu-content width='2' >"
                                            +"<md-menu-item><md-button aria-label='view' class='tmxMin' ng-disabled='!UsersCtrl.ViewPrivilege' ng-click='UsersCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>info</md-icon>Info</md-button></md-menu-item>"
                                                +"<!--md-menu-item><md-button ng-disabled='dataItem.statusActive' aria-label='del' class='tmxMin' ng-click='UsersCtrl.clickEdit(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>edit</md-icon>Edit User</md-button></md-menu-item-->"
                                                +"<md-menu-item ng-if='!dataItem.statusActive && !dataItem.statusPending'><md-button aria-label='del' class='tmxMin' ng-click='UsersCtrl.clickActivate(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>add_circle</md-icon>Activate</md-button></md-menu-item>"
                                                +"<md-menu-item ng-if='dataItem.statusActive && !dataItem.statusPending' ><md-button  aria-label='del' class='tmxMin' ng-disabled='!UsersCtrl.DeletePrivilege' ng-click='UsersCtrl.clickDeactivate(dataItem,$event)'> <md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate</md-button></md-menu-item>"
                                            +"</md-menu-content>"
                                        +"</md-menu>"
                }
 
            ];

            Users.holidayGridColumn = [        
                {
                    field: "HolidayStartDate",
                    title: "Start Date",
                    type: "date",
                    template: "{{UsersEditCtrl.formatDate(dataItem.HolidayStartDate)}}",
                },
                {
                    field: "HolidayEndDate",
                    title: "End Date",
                    type: "date",
                    template: "{{UsersEditCtrl.formatDate(dataItem.HolidayEndDate)}}",
                },
                {
                    field: "IsActive",
                    title: "Active",
                    type: "text",
                    template: "<span ng-bind='UsersEditCtrl.getHolidayStatusVisibleValue(dataItem.IsActive)'></span>",
                },
       
                {
                    field: "IsProcessed",
                    title: "Processed",
                    type: "text",
                    template: "<span ng-bind='UsersEditCtrl.getProcessStatusVisibleValue(dataItem.IsProcessed)'></span>",
                },
                {
                    field: "Action",
                    title: "Action",
                    type: "radio",
                    template: '<md-button class="md-icon-button md-mini circle-button" flex="none" ng-click="UsersEditCtrl.deleteHoliday(dataItem.UserHolidayID)" ng-if="!UsersEditCtrl.HolidayData.UserHolidayID" ng-disabled="UsersEditCtrl.disableHolidayDelete(dataItem)"><md-icon class="material-icons md-warn">remove_circle</md-icon></md-button>',
                }
            ];


            Users.GetUserGridColumns= function(){

        //initializing Lookup types from Tmx Finance Constant
                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


                var userTypes = lookupService.getLocalLookupsByType(lkupType.USER);
                if (userTypes) {
                    Users.recievedLov = true;
                    Users.type = userTypes;
                    Users.gridColumn[3].data = userTypes;
                }
                return Users.gridColumn;
            }


            Users.columns = angular.copy(Users.gridColumn);

            Users.schema = {
                UserId: {
                    duplicate: false,
                    unique: false
                },
                UserCode: {
                    duplicate: true,
                    unique: true
                }
            };
            Users.bulkDelete = function (array) {
                let calls = [];

                function register(company) {
                    calls.push({
                        key: company.UserName,
                        promise: company.$remove()
                    });
                }
                array.forEach(register);
                tmxUtility.getAsynch($q, calls).then(function () {
                });
            };
            return Users;
        }]);
})();
